import { Component, Input, ViewChild } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { IngredientsServices } from "../../../services";
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { CompCreateIngredientPage } from '../../../../components/popups/create-ingredient/create-ingredient';
/**
 * Generated class for the IngredientCompPartialIngSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ingredient-comp-partial-ing-select',
    templateUrl: 'ingredient-comp-partial-ing-select.html',
})
export class IngredientCompPartialIngSelectPage {
    term: string;
    @Input() name;
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };


    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        private toastCtrl: ToastController,
        public ingredientsServices: IngredientsServices,
        public globals: Globals,
        public translate: TranslateService,
        public modalCtrl: ModalController) {

    }

    insert(ingredient) {
        if (!this.check(ingredient.UID)) { //Buscamos si el ingrediente ya esta anadido
            var _array = Array();
            _array.push(ingredient.UID);
            _array.push(ingredient.name);
            _array.push(ingredient.measurement);
            _array.push(ingredient.providers);
            _array.push(ingredient.tax);
            if (ingredient.sub_recipe) {
                _array.push(this.ingredientsServices.returnPricePerMeasurement(ingredient.price_static, ingredient.real_weight));
            } else {
                _array.push(ingredient.price_static);
            }
            _array.push(ingredient.provider_static);
            _array.push(ingredient.tags);

            if (ingredient.allergens == undefined) {
                ingredient.allergens = [];
                _array.push(ingredient.allergens);
            } else {
                _array.push(ingredient.allergens);
            }
            _array.push(ingredient.stock_alert);
            _array.push(ingredient.stock);
            _array.push(ingredient.sub_recipe);
            _array.push(0);//cantidad
            _array.push(0);//cantidad bruta
            _array.push(0);//merma
            _array.push(0);//preu final
            _array.push(0);//total
            _array.push(ingredient.foodcost);
            _array.push(ingredient.real_weight);

            this.ingredientsServices.ingredients_array_tmp.push(_array);
            this.ingredientsServices.ingredients_array_tmp = [...this.ingredientsServices.ingredients_array_tmp];
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-ingrediente') + ' ' + ingredient.name + ' ' + this.translate.instant('instant-anadido-correctemente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-ingrediente-esta-anadido-lista'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    check(value) {
        var response = false;
        for (var i = 0; i < this.ingredientsServices.ingredients_array_tmp.length; i++) {
            var obj = this.ingredientsServices.ingredients_array_tmp[i];
            if (obj[0] == value) {
                response = true;
            }
        }
        return response;
    }
    nextPage() {
        if (this.ingredientsServices.page_active < this.ingredientsServices.pagesIngredients.length) {
            this.ingredientsServices.page_active += 1
        }
        this.ingredientsServices.getListIngredientsMinMax();
        document.getElementById('scroll_ing_select').scrollIntoView({
            behavior: 'smooth'
        });
    }
    previusPage() {
        if (this.ingredientsServices.page_active > 1) {
            this.ingredientsServices.page_active -= 1;
        }
        this.ingredientsServices.getListIngredientsMinMax();
        document.getElementById('scroll_ing_select').scrollIntoView({
            behavior: 'smooth'
        });
    }
    activePage(number) {
        this.ingredientsServices.page_active = number;
        this.ingredientsServices.getListIngredientsMinMax();
        document.getElementById('scroll_ing_select').scrollIntoView({
            behavior: 'smooth'
        });
    }
    clickElement(event) {
        if (event.type == 'click') {
            this.insert(event.row);
        }
    }

    openCreateIngredient() {
        let profileModal = this.modalCtrl.create(CompCreateIngredientPage, {
            origin: 'ingredient'
        });
        profileModal.present();
    }
}


// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-comp-create/ingredient-comp-create-select-ing/ingredient-comp-partial-ing-select/ingredient-comp-partial-ing-select.ts